import { Card, ConfigProvider, Space } from 'antd';
import { useCallback, useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { CreateTicketFormValues } from '../../../../../../../../types/form';
import ResetFormButton from '../../../../../../../components/Forms/ResetFormButton';
import FormSelectInput from '../../../../../../../components/TicketPage/FormSelectInput';
import useFormName from '../../../../../../../hooks/ticketDetailPage/useFormName';
import { BasicFormMethodsContext } from '../../../../../../../store/provider/BasicFormMethodsProvider';
import AgentFormActiveFieldsContainer from '../../../AgentFormActiveFieldsContainer';

const CreateTicketFieldsContainer = (): JSX.Element => {
    const {
        formState: { isDirty }
    } = useFormContext<CreateTicketFormValues>();
    const formName = useFormName();

    const { resetForm } = useContext(BasicFormMethodsContext);
    const onClick = useCallback(() => resetForm(formName), [resetForm, formName]);

    return (
        <ConfigProvider getPopupContainer={(trigger) => trigger?.parentElement}>
            <Space direction="vertical" size="small" className="full-width">
                <Card
                    bodyStyle={{ padding: '12px' }}
                    style={{ borderRadius: '5px', border: '1px solid rgba(0, 0, 0, 0.12)', marginTop: '10px' }}
                >
                    <FormSelectInput />
                </Card>
                <Card
                    bodyStyle={{ padding: '12px' }}
                    style={{ borderRadius: '5px', border: '1px solid rgba(0, 0, 0, 0.12)', marginBottom: '10px' }}
                >
                    <Space direction="vertical" size="small" className="full-width">
                        <AgentFormActiveFieldsContainer />
                        <Space style={{ marginTop: '10px' }}>
                            <ResetFormButton onClick={onClick} disabled={!isDirty} />
                        </Space>
                    </Space>
                </Card>
            </Space>
        </ConfigProvider>
    );
};

export default CreateTicketFieldsContainer;
